import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBanks } from '../models/banks.model';
import { fromStaticDataBanksAction } from '../actions';

export const banksFeatureKey = 'banks';

export interface State {
  banksResponse: IBanks[];
  banksFailure: IGenericError<ErrorResponse>;
}

export const initialState: State = {
  banksResponse: undefined,
  banksFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataBanksAction.loadBanksSuccess, (state, action) => ({
    ...state,
    banksResponse: action.response
  })),

  on(fromStaticDataBanksAction.loadBanksFailure, (state, action) => ({
    ...state,
    banksFailure: action.error
  }))
);

export const getStaticDataBanksResponse = (state: State) => state.banksResponse;
export const getStaticDataBanksFailure = (state: State) => state.banksFailure;
